import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import { FDStack } from '@facet-wealth/design';
import {
  ItemInfoCard,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingMindsetTemplate/Layout/ItemInfoCard';
import fr from 'facet-rest';

const Layout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const itemInformationRecords = resource.attr('itemInformationRecords').resources().list();

  return (
    <PageContentContainer>
      <FDStack
        direction={'column'}
        spacing={4}
        alignItems={'center'}
      >
        <PageContentTop
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
        <FDStack
          direction={'column'}
          spacing={4}
          justifyContent={'center'}
        >
          {itemInformationRecords.map((itemInfo) => (
            <ItemInfoCard
              key={itemInfo.id()}
              mediaSrc={itemInfo.relationship(fr.relationships.media.name)?.link('related').url()}
              title={itemInfo.attr('title')}
              description={itemInfo.attr('description')}
            />
          ))}
        </FDStack>
      </FDStack>
    </PageContentContainer>
  );
};

export { Layout };
